import React from "react";
import { NavLink } from "react-router";
import Wrapper from "../hooks/wrapper";

import { RiInstagramFill, RiMailFill, RiLinkedinBoxFill } from "react-icons/ri";

import "../Components.css";

function Contact() {
  return (
    <Wrapper>
      <div className="Pages">
        <div className="PageTitle">
          <span>CONTACT</span>
          <NavLink to="/">← Previous</NavLink>
        </div>
        <div className="PageContent">
          <div>
            <ul className="ContactList">
              <li>
                <RiInstagramFill />
                <span>@gyeong_studio</span>
              </li>
              <li>
                <RiMailFill />
                <span>leegyeongmin@outlook.com</span>
              </li>
              <li>
                <RiLinkedinBoxFill />
                <span>linkedin.com/in/leegyeongmin</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Contact;
